import { array, object, string } from 'yup';

export const teamSettingsSchema = object().shape({
  jobShareNotificationTo: array().of(string().email()).min(0),
  jobClosedNotificationTo: array().of(string().email()).min(0),
  jobInsightUpdateNotificationTo: array().of(string().email()).min(0),
  candidateSubmissionNotificationTo: array().of(string().email()).min(0),
  candidateStatusUpdateNotificationTo: array().of(string().email()).min(0),
  disableJobShareNotificationTo: array().of(string().email()).min(0),
  disableJobClosedNotificationTo: array().of(string().email()).min(0),
  disableJobInsightUpdateNotificationTo: array().of(string().email()).min(0),
  disableCandidateSubmissionNotificationTo: array().of(string().email()).min(0),
  disableCandidateStatusUpdateNotificationTo: array().of(string().email()).min(0),
});

export const invitesSearchSchema = object().shape({
  invitesSearch: string().email('Not an email'),
});

export const teamSchema = object().shape({
  teamName: string().required('Please enter a team name'),
});
